import React, { Component } from 'react';
import { view } from './restApi';
import ButtonLink, { InvertedButtonLink } from '../components/output/ButtonLink';
import { classNames } from '../functions/classNames';
import './Crud.css';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import WithRole from '../components/container/WithRole';

class View extends Component {
  constructor(props) {
    super(props);

    this.state = { resource: {} };

    view(props.entityName, props.entityId)
      .then(data => this.setState({ resource: data }));
  }

  renderButtons = ({ entityName, entityRoute, entityId }) => (
    <div>
      <WithRole roles={['A', 'B']}>
        <ButtonLink
            to={'/' + entityRoute + '/edit/' + entityId}
            label="general.modify"
            style={{ marginLeft: '10px' }}
        />
      </WithRole>
      <InvertedButtonLink
          to={'/' + entityRoute}
          label="general.close"
          style={{ marginLeft: '10px' }}
      />
    </div>
  );

  render() {
    const buttons = this.props.buttons ? this.props.buttons(this.props, this.state.resource) : this.renderButtons(this.props);
    const childrenWithProps = React.Children.map(this.props.children,
      child => React.cloneElement(child, {
        resource: this.state.resource,
      })
    );

    return (
      <div className={classNames('Crud', 'View', this.props.crudClassName)}>
        <h2>{getLabel(this.context.locale, 'general.view') + ' ' + getLabel(this.context.locale, this.props.title)}</h2>
        {childrenWithProps}
        {buttons}
      </div>
    );
  }
}

View.contextTypes = {
  locale: PropTypes.string,
};

export default View;



// WEBPACK FOOTER //
// ./src/main/cruds/View.js